import { Box, Title, Group, Divider } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { ActionButton } from './ActionButton';
import { AppTooltip } from './AppTooltip';

interface SectionHeaderProps {
  title: string;
  infoTooltip?: ReactNode;
  action?: {
    label: string;
    onClick: () => void;
    ariaLabel?: string;
  };
}

export function SectionHeader({ title, infoTooltip, action }: Readonly<SectionHeaderProps>) {
  return (
    <Box>
      <Group position="apart" mb="lg">
        <Group spacing="xs" align="center">
          <Title order={3} weight={500}>
            {title}
          </Title>
          {infoTooltip ? (
            <AppTooltip label={infoTooltip} maxWidth={340}>
              <IconInfoCircle
                size={18}
                style={{ color: 'var(--mantine-color-dimmed)', cursor: 'help' }}
                aria-label="Metrics freshness information"
              />
            </AppTooltip>
          ) : null}
        </Group>
        {action && (
          <ActionButton
            onClick={action.onClick}
            label={action.label}
            ariaLabel={action.ariaLabel || action.label}
            actionType="secondary"
          />
        )}
      </Group>
      <Divider mb="lg" />
    </Box>
  );
} 